module.exports = __webpack_public_path__ + "static/media/hannan-uddin-web-developer.984db267.jpg";